import { TableEmptyState } from '@practium/ui';
import type { AgriculturalDefensive } from '../../../types';
import styles from './DefensivesTable.module.css';

const NATURE_LABELS: Record<string, string> = {
	solid: 'Sólido',
	liquid: 'Líquido',
};

interface DefensivesTableProps {
	defensives: AgriculturalDefensive[];
	resolveUserName: (userId: string | null) => string;
	onRowClick?: (id: string) => void;
}

export const DefensivesTable = ({
	defensives,
	resolveUserName,
	onRowClick,
}: DefensivesTableProps) => {
	if (defensives.length === 0) {
		return (
			<TableEmptyState
				title="Nenhum defensivo encontrado"
				subtitle="Adicione um defensivo agrícola para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome do Produto</th>
						<th>Fabricante</th>
						<th>Cultura</th>
						<th>Classe</th>
						<th>Natureza</th>
						<th>Origem</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{defensives.map((item) => {
						const isAdmin = item.userId === null;
						const originLabel = isAdmin ? 'Admin' : resolveUserName(item.userId);
						return (
							<tr
								key={item._id}
								onClick={() => onRowClick?.(item._id)}
								className={onRowClick ? styles.clickableRow : undefined}
							>
								<td>
									<span className={styles.cellPrimary}>{item.commercialName}</span>
								</td>
								<td>
									<span className={styles.cellSecondary}>
										{item.manufacturer?.tradingName ?? item.manufacturer?.businessName ?? '—'}
									</span>
								</td>
								<td>
									<span className={styles.cellSecondary}>{(item.culture ?? []).join('/')}</span>
								</td>
								<td>
									<span className={styles.cellSecondary}>{Array.isArray(item.class) ? item.class.join(', ') : item.class}</span>
								</td>
								<td>
									<span className={styles.cellSecondary}>
										{item.nature ? (NATURE_LABELS[item.nature] ?? item.nature) : '—'}
									</span>
								</td>
								<td>
									<span
										className={`${styles.originBadge} ${
											isAdmin ? styles.originBadgeAdmin : styles.originBadgeClient
										}`}
									>
										{originLabel}
									</span>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};
